function parseMoney(value) {
  if (!value) return 0;
  const normalized = value.replace(/[^0-9.,-]/g, "").replace(/,/g, "");
  return parseFloat(normalized) || 0;
}

function updatePercentOffBadge() {
  const quantityBreaks = document.querySelector("quantity-breaks");
  if (!quantityBreaks) return;

  const productInfo = quantityBreaks.closest("product-info");
  if (!productInfo) return;

  const badge = productInfo.querySelector(".price__percent-off-badge");
  if (!badge) return;

  const checkedInput = quantityBreaks.querySelector('[name="quantity"]:checked');
  if (!checkedInput) return;

  const label = checkedInput.nextElementSibling;
  const dynamicPrice = label?.querySelector(".quantity-break__right.dynamic-price");
  const regularPriceEl = dynamicPrice?.querySelector(".quantity-break__price");
  const comparePriceEl = dynamicPrice?.querySelector(".quantity-break__compare-price");

  const regular = regularPriceEl ? parseMoney(regularPriceEl.textContent) : 0;
  const compare = comparePriceEl ? parseMoney(comparePriceEl.textContent) : 0;
  const noDiscount =
    !regularPriceEl ||
    !comparePriceEl ||
    comparePriceEl.classList.contains("hidden") ||
    compare <= regular;

  // No discount on the selected pack (e.g. the 1-pack when anchored on itself):
  // hide the badge rather than leaving a stale percentage from the prior selection.
  if (noDiscount) {
    badge.classList.add("hidden");
    return;
  }
  badge.classList.remove("hidden");

  const percent = Math.floor(((compare - regular) / compare) * 100);
  const template = badge.dataset.textTemplate || "[percentage] OFF";
  badge.textContent = template.replace("[percentage]", `${percent}%`);
}

function updatePriceFromQuantityBreaks() {
  const quantityBreaks = document.querySelector("quantity-breaks");
  if (!quantityBreaks) return;

  const checkedInput = quantityBreaks.querySelector('[name="quantity"]:checked');
  if (!checkedInput) return;

  const label = checkedInput.nextElementSibling;
  if (!label) return;

  const dynamicPrice = label.querySelector(".quantity-break__right.dynamic-price");
  if (!dynamicPrice) return;

  const regularPriceEl = dynamicPrice.querySelector('.quantity-break__price');
  const comparePriceEl = dynamicPrice.querySelector('.quantity-break__compare-price');
  if (!regularPriceEl || !comparePriceEl) return;

  const regularPrice = regularPriceEl.textContent.trim();
  const comparePrice = comparePriceEl.textContent.trim();
  const showCompare =
    !comparePriceEl.classList.contains("hidden") &&
    parseMoney(comparePrice) > parseMoney(regularPrice);

  const productInfo = quantityBreaks.closest("product-info");
  if (!productInfo) return;

  const priceItem = productInfo.querySelector(".price-item");
  if (!priceItem) return;

  priceItem.innerHTML = showCompare
    ? `
    <span class="sale-price">${regularPrice}</span>
    <span class="compare-at-price">${comparePrice}</span>
  `
    : `
    <span class="sale-price">${regularPrice}</span>
  `;

  updatePercentOffBadge();
}

document.addEventListener("DOMContentLoaded", () => {
  updatePriceFromQuantityBreaks();
  updatePercentOffBadge();

  document.addEventListener("change", (e) => {
    if (e.target.matches('[name="quantity"]')) {
      updatePriceFromQuantityBreaks();
      updatePercentOffBadge();
    }
  });
});

// Back/forward cache restore (pageshow with persisted=true) does NOT re-fire
// DOMContentLoaded or a change event, but the browser DOES restore the previously
// checked pack radio. Without this, the header price/badge stay stuck on whatever
// they last rendered (often the default Buy 3) while a different pack is selected.
// Re-sync on every pageshow -- idempotent, so a normal load is unaffected.
window.addEventListener("pageshow", () => {
  updatePriceFromQuantityBreaks();
  updatePercentOffBadge();
});